"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectItem = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var RadixSelect = __importStar(require("@radix-ui/react-select"));
var react_1 = require("@stitches/react");
var stitches_config_1 = require("../stitches.config");
var Text_1 = require("./Text");
var Tooltip_1 = require("./Tooltip");
var StyledSelectItem = (0, react_1.styled)(RadixSelect.Item, {
    display: "flex",
    alignItems: "center",
    marginLeft: "auto",
    padding: "8px",
    background: stitches_config_1.theme.colors.white,
    outline: "none",
    flexDirection: "row",
    position: "relative",
    gap: "6px",
    borderRadius: stitches_config_1.theme.shape.borderRadius,
    "&:hover": {
        background: stitches_config_1.theme.colors.gray4,
    },
    "&[data-disabled]": {
        opacity: 0.5,
        cursor: "not-allowed",
    },
    // This was lazy because couldn't figure out why badges weren't using the not-allowed cursor
    "&[data-disabled] *": {
        cursor: "not-allowed",
    },
});
var StyledIndicatorWrapper = (0, react_1.styled)("div", {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "20px",
});
var StyledIndicator = (0, react_1.styled)(RadixSelect.ItemIndicator, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "16px",
    height: "20px",
});
var IconContainer = (0, react_1.styled)("div", {
    height: "100%",
    display: "flex",
    alignItems: "center",
});
// Probably should have a utility function somewhere or build this directly into the tooltip component
// Don't copy this pattern this was lazy of me
var WithTooltip = function (props) {
    return props.tooltip ? ((0, jsx_runtime_1.jsx)(Tooltip_1.Tooltip, __assign({ text: props.tooltip }, { children: props.children }))) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.children }));
};
function SelectItem(props) {
    // See above note for WithTooltip usage and laziness around it
    return ((0, jsx_runtime_1.jsx)(WithTooltip, __assign({ tooltip: props.tooltip }, { children: (0, jsx_runtime_1.jsx)(StyledSelectItem, __assign({ value: props.value, disabled: props.disabled }, { children: (0, jsx_runtime_1.jsxs)(RadixSelect.ItemText, { children: [typeof props.label === "string" ? ((0, jsx_runtime_1.jsx)(Text_1.Text, __assign({ variant: "text-sm-plus" }, { children: props.label }))) : (props.label), props.icon && (0, jsx_runtime_1.jsx)(IconContainer, { children: props.icon })] }) })) })));
}
exports.SelectItem = SelectItem;
//# sourceMappingURL=SelectItem.js.map